export enum ApplicatinSchemeType {
  INDIVIDUAL = 'INDIVIDUAL',
  CORPORATE = 'CORPORATE',
  COMPANY_OFFICIAL = 'COMPANY_OFFICIAL',
}

export enum ApplicationSettingsEnum {
  CREATE_INDIVIDUAL_ORGANIZATION_BY_CUSTOMER_AVAILABLE = 'CREATE-INDIVIDUAL-ORGANIZATION-BY-CUSTOMER-AVAILABLE',
  CREATE_CORPORATE_ORGANIZATION_BY_CUSTOMER_AVAILABLE = 'CREATE-CORPORATE-ORGANIZATION-BY-CUSTOMER-AVAILABLE',
}

export enum ClientType {
  INDIVIDUAL = 'INDIVIDUAL',
  CORPORATE = 'CORPORATE',
}

export interface ClientScheme {
  name: string;
  primaryId?: string;
  transactionRiskScoringEnabled: boolean;
  transactionMonitoringEnabled: boolean;
  transactionBlacklistEnabled: boolean;
  transactionAgreementEnabled: boolean;
  currencies: {
    edges: any[];
  };
  id: string;
}

export interface ApplicationScheme {
  name: string;
  type: ApplicatinSchemeType;
  active: boolean;
  visible: boolean;
  deliveryChannelVisible?: boolean;
  deliveryChannelTitle?: string;
  deliveryChannelId?: string;
  countriesOfInterestActive?: boolean;
  countriesOfInterestTitle?: string;
  clientSchemeId?: string;
  deliveryChannel: {
    name: string;
    active: boolean;
    riskScoreRangeId: string;
    riskScore: number;
    clientType: ClientType;
    id: string;
  };
  clientScheme: ClientScheme;
  documentsCategories: {
    edges: any[];
  };
  id: string;
  render?: Record<string, React.JSX.Element>;
}
